import {Types} from "../actions/payScheduleActions";
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';

const payScheduleReducers = (state, action) => {
    console.log('inpayScheduleReducers',action.type)
    switch (action.type) {
        case Types.PAYSCHEDULE_ADD: {
            let newState = _.cloneDeep(state);

            const paySchedule = { id: uuidv4(), payFrequency: 12}

            if (action.payScheduleType){
                paySchedule.type = action.payScheduleType
            }

            if(action.newCompany) {
                newState.company.newCompany.paySchedules = newState.company.newCompany.paySchedules || [];
                newState.company.newCompany.paySchedules.push(paySchedule);
            } else {
                newState.company.settings.paySchedules = newState.company.settings.paySchedules || [];
                newState.company.settings.paySchedules.push({...paySchedule, temporary: true});
            }

            return newState;
        }
        case Types.PAYSCHEDULE_UPDATE_FIELD: {
            let newState = _.cloneDeep(state);

            const prop = action.newCompany ? 'newCompany' : 'settings'

            console.log('action',action)

            let paySchedule = newState.company[prop].paySchedules.find(item => item.id == action.id)

            
            console.log('paySchedule',paySchedule)

            if (!paySchedule[action.field]){
                paySchedule[action.field] = {}
            }

            if(action.newValue == "of the period") {
                delete paySchedule[action.field].value
            }

            if(action.fieldType) 
                paySchedule[action.field][action.fieldType] = action.newValue;
            else paySchedule[action.field] = action.newValue;
        
            return newState;
          }
        default:
         return state;
    }
};

export default payScheduleReducers;